export default __webpack_public_path__ + "static/media/6.93378c57.jpg";